module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/domofon-1-a53c840d03a1025d302b69bae80ff8ab.png";